interface ApiPathType {
  signIn: string;
  signUp: string;
  forgotPassword: string;
  resetPassword: string;
  setNewPassword: string;
  changePassword: {
    customerPwdOTPRequest: string;
    customerPwdOTPvalidate: string;
  };
  socialLogin: {
    google: string;
    apple: string;
  };
  requestOtp: {
    email: string;
    mobile: string;
  };
  verifyOtp: {
    email: string;
    mobile: string;
  };
  checkToken: string;
  updateCustomer: string;

  cotegoryList: string;
  categoriesListById: string;
  getRoleList: string;
  getPermissionById: string;
  refreshToken: string;
  getAllEmployees: string;
  getEmployee: string;
  getEmployeeByRoleId: string;
  getProductsDetails: string;
  getAllProducts: string;
  searchProducts: string;
  customersList: string;
  customerById: string;
  getCouponList: string;
  getOrdersList: string;
  getOrderDetails: string;
  allCustomers: string;
  customers: string;
  faqList: string;
  productFaqList: string;
  faqProductList: string;
  getTerms: string;
  getPrivacyPolicy: string;
  getBanners: string;
  getBankDetails: string;
  getCountry: string;
  countryDialingInfoApi: string;
  getCitiesList: string;
  getTripsList: string;
  getSeatsList: string;
  getCartList: string;
  addTicketToBusCart: string;
  deleteTicketFromBusCart: string;
  addSeatReservationList: string;
  deleteSeatReservation: string;
  cancelFlixBusOrder: string;

  createCartList: string;
  getAllCountry: string;
  customerHomeLayoutListById: string;
  customerHomeLayoutList: string;
  ratingAndReviewByProductId: string;
  helpService: string;
  helpComments: string;
  createHelpTicket: string;
  getHelpTicketByCustomer: string;
  newsLetter: string;
  customerLogout: string;

  addWishlist: string;
  updateWishlist: string;
  removeWishlistItem: string;
  removeAllWishlistItems: string;
  getWishlist: string;
  checkProductAreaInWishlist: string;
  checkWishlistProducts: string;
  getProductEstimation: string;
  getLuggageDetails: string;

  /**Cart Management */
  addToCart: string;
  buyNow: string;
  getBuyNow: string;
  removeBuyNowItem: string;
  getCart: string;
  removeCart: string;

  createCustomerAddress: string;
  getCustomerAddress: string;
  deleteCustomerAddress: string;
  createOrder: string;
  updateOrder: string;
  createStripePayment: string;
  getMyOrders: string;
  helpRecentOrders: string;
  tripJourneyDetail: string;
  downloadInvoice: string;
  creditMemoDownload: string;
  orderCreditMemos: string;
  refundInvoiceDownload: string;
  orderRefundInvoices: string;

  getCustomerOrderPin: string;
  getorderitemswithpins: string;
  getOrderSocketStatus: string;

  /**@RATING MANAGEMENT */
  getReviewAndRating: string;
  createReview: string;
  updateReview: string;

  /**@LANDING PAGE MANAGEMENT */
  mobileLookup: string;
  countryWiseAllProvider: string;

  /**@RECHARGE_MOBILE_NO_VALIDATE */
  mobileNoValidate: string;

  sendOtpForEmail: string;

  /* Footer Management */
  footer: string;
}

const ApiPath: ApiPathType = {
  /**Auth Management */
  signIn: `/customerlogin` as const,
  signUp: `/createcustomer` as const,
  forgotPassword: `/customerfrgtpassword` as const,
  resetPassword: `/customer-reset-password` as const,
  checkToken: `/customer_checkToken` as const,
  setNewPassword: `/customer-set-new-password` as const,
  changePassword: {
    customerPwdOTPRequest: "customer-password-updatereq",
    customerPwdOTPvalidate: "customer-password-otpvalidate",
  },
  socialLogin: {
    google: `/auth/google`,
    apple: `/auth/apple`,
  },

  requestOtp: {
    email: "customer-sendOtptoEmail",
    mobile: "customer-sendOtptoMobile",
  },
  verifyOtp: {
    email: "customer-verifyOtpfromEmail",
    mobile: "customer-verifyOtpfromMobile",
  },
  updateCustomer: "updatecustomer",

  /**Category Management */
  cotegoryList: `/category` as const,
  categoriesListById: `/category${""}` as const,

  /**Role Management */
  getRoleList: `/roles` as const,
  getPermissionById: `/roles${""}` as const,
  refreshToken: `/customer-refresh-token` as const,

  /**Employee Management */
  getAllEmployees: `/allemployee` as const,
  getEmployee: `/employee` as const,
  getEmployeeByRoleId: `/rolewiseemp${""}` as const,

  /**Products Management */
  getProductsDetails: `/product${""}` as const,
  getAllProducts: `/allproduct` as const,
  searchProducts: `/product/search${""}` as const,

  // Add to wish list
  addWishlist: `/addwishlist` as const,
  updateWishlist: `/updateWishlist` as const,
  removeWishlistItem: `/removewishlistitem${""}` as const,
  removeAllWishlistItems: `/removeallwishlistitems${""}` as const,
  getWishlist: `/getwishlist${""}` as const,
  checkProductAreaInWishlist: `/checkproductareainwishlist${""}` as const,
  checkWishlistProducts: `/checkWishlistProducts` as const,
  getProductEstimation: `/getTaxProduct` as const,

  /**Rating & Review Management */
  ratingAndReviewByProductId: `/ratingandreview${""}` as const,

  /**Customers Management */
  allCustomers: `/allcustomers` as const,
  customersList: `/customers` as const,

  /**Coupon Management */
  getCouponList: `/coupon` as const,

  /**Order Management */
  getOrdersList: `/orders-list` as const,
  getOrderDetails: `/orders${""}` as const,
  downloadInvoice: `/orderinvoice${""}` as const,
  creditMemoDownload: `/creditmemo-download` as const,
  orderCreditMemos: `/order-creditmemos` as const,
  refundInvoiceDownload: `/refundinvoice-download` as const,
  orderRefundInvoices: `/order-refundinvoices` as const,

  customers: `/customers` as const,
  customerById: `/customer${""}` as const,

  /**FAQ Management */
  faqList: `/faq` as const,
  productFaqList: "/productfaq" as const,

  /**FAQ Product Management */
  faqProductList: `/productidbyfaqs` as const,

  /**Term & Condition */
  getTerms: `/termscnd` as const,

  /**Privacy Policy */
  getPrivacyPolicy: `/privacyplcy` as const,

  /**Banner for Web/Mobile APP */
  getBanners: `/banner` as const,

  /**Bank Details */
  getBankDetails: `/bankdetails` as const,

  /**get Country for Web/Mobile APP */
  getCountry: `/country` as const,
  countryDialingInfoApi: `/country-dialing-info` as const,
  getAllCountry: `/allcountry` as const,
  getCitiesList: `/cities` as const,
  getTripsList: `/trips` as const,
  getSeatsList: `/seats` as const,
  createCartList: `/createBusCart` as const,
  getCartList: `/getBusCart` as const,
  addTicketToBusCart: `/addTicketToBusCart` as const,
  deleteTicketFromBusCart: `/removeTicketFromBusCart` as const,
  addSeatReservationList: `/addSeatReservation` as const, // ✅ Add this line
  getLuggageDetails: `/ancillaries` as const,
  deleteSeatReservation:
    `/deleteseatfromreservation/:cart_id/:cart_id_reservation` as const,
  cancelFlixBusOrder: `/cancelorder/orderId/token/ordernumber` as const,
  /**cUSTOMER Home for Web/Mobile APP */
  customerHomeLayoutList: `/gethome` as const,
  customerHomeLayoutListById: `/gethome${""}` as const,

  /**Help Service*/
  helpService: `/helpservice` as const,
  helpComments: `/helpcomments` as const,
  createHelpTicket: `/createTicket` as const,
  getHelpTicketByCustomer: `/getTicketByCustomerId${""}` as const,

  /**News Letter */
  newsLetter: `/newsLetter` as const,
  customerLogout: `/customer-logout${""}` as const,

  /**@ADD_TO_CART_AND_GET_CART_ITEMS */
  addToCart: `/addtocart` as const,
  getCart: `/getcart` as const,
  removeCart: `/removecartitem${""}` as const,
  buyNow: `/buyNow/create` as const,
  getBuyNow: `/buyNow/getByUserId` as const,
  removeBuyNowItem: `/buyNow/delete` as const,

  createCustomerAddress: `/customeraddress` as const,
  getCustomerAddress: `/getcustomeraddress` as const,
  deleteCustomerAddress: `/deleteCustomerAddress${""}${""}` as const,
  createOrder: `/createorder` as const,
  createStripePayment: `/create-session${""}` as const,
  getMyOrders: `/orders` as const,
  // Orders a query may be raised about: the customer's own, last 7 days.
  helpRecentOrders: `/help/recent-orders` as const,
  // Stops, per-leg times and the transfer window, from FlixBus's v1 endpoint.
  tripJourneyDetail: `/trip-journey-detail` as const,
  updateOrder: `/updateorder${""}` as const,
  getCustomerOrderPin: `/getcustomerpin${""}` as const,
  getorderitemswithpins: `/getorderitemswithpins${""}` as const,
  getOrderSocketStatus: `/order/socket${""}` as const,

  /**Rating*/
  getReviewAndRating: `/ratings` as const,
  createReview: `/createreview` as const,
  updateReview: `/updatereview${""}` as const,

  /**Landing Page Management (mobile recharge) */
  mobileLookup: `/externalapi/mobile-lookup` as const,
  countryWiseAllProvider: `/externalapi/moblie-products` as const,

  /**@RECHARGE */
  mobileNoValidate: `/externalapi/mobileno-validate` as const,

  sendOtpForEmail: `/customer-sendOtptoEmail` as const,

  /* Footer Management */

  footer: `/footer` as const,
};
export default ApiPath;
